export function serializeMap(
  map: Map<any, any>,
  keyDelimiter: string = ';',
  valueDelimiter: string = ',',
): string {
  return Object.entries(Object.fromEntries(map))
    .map(([k, v]) => `${k}${valueDelimiter}${v}`)
    .join(keyDelimiter);
}

export function socialSecurityNumberFormatter(raw: string): string {
  return `${raw.substr(0, 3)}-${raw.substr(3, 3)}-${raw.substr(6, 3)}`;
}

export function deepOverwrite(original: any, current: any): any {
  return Object.entries(original).reduce((output, [key, originalValue]) => {
    const targetValue = current[key];
    if (originalValue === null && typeof targetValue === "object") {
      return { ...output, [key]: targetValue };
    }
    if (targetValue === null && typeof originalValue === "object") {
      return { ...output, [key]: null };
    }
    if (
      typeof originalValue === "object" &&
      typeof targetValue === "object"
    ) {
      return {
        ...output,
        [key]: deepOverwrite(originalValue, targetValue)
      };
    }
    return { ...output, [key]: targetValue };
  }, {});
}